import * as ActionTypes from '../constants/ActionTypes'

// **************************************************************************************************************
export const toggleCollapsibleContent = (toggleId) => ({
    type: ActionTypes.COLLAPSIBLE_CONTENT_TOGGLED,
    toggleId: toggleId
})
export const openCollapsibleContent = (toggleId) => ({
    type: ActionTypes.COLLAPSIBLE_OPEN_CONTENT,
    toggleId: toggleId
})
export const closeCollapsibleContent = (toggleId) => ({
    type: ActionTypes.COLLAPSIBLE_CLOSE_CONTENT,
    toggleId: toggleId
})

export const toggleSelectionTriggered = (selectionId, selectedContentId) => ({
    type: ActionTypes.TOGGLE_SELECTION_TRIGGERED,
    selectionId: selectionId,
    selectedContentId: selectedContentId
})



/** WEBPACK FOOTER **
 ** ./src/actions/Util.js
 **/